import Axios from 'helpers/http'
import generateFaberHostName from 'helpers/http/generateFaberHostname'

const FaberApi = new Axios(generateFaberHostName(), '/v1/labs')

export default FaberApi
